import React from 'react';
import './AboutMe.css';

const AboutMe = () => (
  <section className="about-me">
    <h2>Hi, I'm Amiah</h2>
    <div className="about-content">
      <img src="/about-me.jpg" alt="Your profile" className="about-img" />
      <div className="about-text-columns">
        <p>
          This is my full-time job, and I have taken care of many different kinds
          of animals my whole life. I have raised puppies, cats, reptiles, and
          plenty of farm animals. I am available 7 days a week to walk, play,
          train, and care for your pets while making sure they stay mentally and
          physically engaged.
        </p>
        <p>
          I also offer bookings for small animals and farm pets, plus flexible
          scheduling including holidays. Your pet receives frequent potty breaks,
          longer walks, and optional pickup or drop-off support. I provide a
          safe, clean, and loving environment with constant supervision and care
          tailored to each pet's routine and comfort level.
        </p>
      </div>
    </div>
  </section>
);

export default AboutMe;
